<script>
  import { createEventDispatcher } from 'svelte';
  import { format } from 'svelte-i18n';
  import { Alert, Button, ListGroup, Modal, ModalBody, ModalFooter, ModalHeader } from '@sveltestrap/sveltestrap';

  import { Spinner } from '@client/components/spinner';

  import { SyncService } from '@client/services/sync';

  import HistoryItem from './history-item.svelte';

  export let show = false;

  const dispatch = createEventDispatcher();

  const toggle = () => dispatch('close');

  let history = [];
  let loading = false;

  const getSyncHistory = async () => {
    loading = true;
    try {
      history = await SyncService.getSyncHistory();
    } finally {
      loading = false;
    }
  };

  $: if (show) {
    getSyncHistory();
  }
</script>

<Modal bind:isOpen={show} scrollable size="sm">
  <ModalHeader {toggle}>
    {$format('label.SYNC_HISTORY')}
  </ModalHeader>
  <ModalBody>
    {#if loading}
      <div class="loading">
        <div>
          <Spinner show inline />
          {$format('label.LOADING')}&hellip;
        </div>
      </div>
    {:else if !history.length}
      <Alert color="info" class="mb-0">
        {$format('label.SYNC_HISTORY_EMPTY')}
      </Alert>
    {:else}
      <ListGroup flush>
        {#each history as event}
          <HistoryItem {event} />
        {/each}
      </ListGroup>
    {/if}
  </ModalBody>
  <ModalFooter>
    <Button color="primary" on:click={toggle}>{$format('label.CLOSE')}</Button>
  </ModalFooter>
</Modal>

<style lang="scss" src="./history-modal.scss"></style>
